// Define the configuration schema
interface ConfigSchema {
  env: 'production' | 'development';
  walletConnect: {
    projectId: string;
  };
  coingecko: {
    baseUrl: string;
    credentials: string;
  };
  alchemy: {
    apiKey: string;
  };
  coindesk: {
    baseUrl: string;
    credentials: string;
  };
  subgraph: {
    url: string;
  };
  ipKyc: {
    baseUrl: string;
  };
}

// Get environment variables from process.env
const getEnvVar = (key: string, defaultValue: string = ''): string => {
  return process.env[key] || defaultValue;
};

// Create the configuration object
const config: ConfigSchema = {
  env: (getEnvVar('REACT_APP_ENV') || 'development') as 'production' | 'development',
  walletConnect: {
    projectId: getEnvVar('REACT_APP_WALLET_CONNECT_PROJECT_ID', '7a241eba9bb63d2bee3215c316fb9fa3'),
  },
  coingecko: {
    baseUrl: getEnvVar('REACT_APP_COINGECKO_BASE_URL', 'https://api.coingecko.com/api/v3'),
    credentials: getEnvVar('REACT_APP_COINGECKO_CREDENTIALS', 'CG-iwMszTbBw9XK67iwToYDH28g'),
  },
  alchemy: {
    apiKey: getEnvVar('REACT_APP_ALCHEMY_API_KEY', 'V7jhh-NcjSGv3F5MehTYL0d1ShQjHUb4'),
  },
  coindesk: {
    baseUrl: getEnvVar('REACT_APP_COINDESK_BASE_URL', 'https://data-api.coindesk.com/news/v1'),
    credentials: getEnvVar(
      'REACT_APP_COINDESK_CREDENTIALS',
      'f6261985f28f3a934e95e81a56a8f2754362bbfc5d3094ab089b681092b09f23'
    ),
  },
  subgraph: {
    url: getEnvVar(
      'REACT_APP_SUBGRAPH_URL',
      'https://api.studio.thegraph.com/query/43740/token-racer-subgraph-canary/version/latest'
    ),
  },
  ipKyc: {
    baseUrl: getEnvVar('REACT_APP_IP_KYC_BASE_URL', 'https://app.ithacaprotocol.io/api/ip'),
  },
};

// Helper function to get configuration values
const get = (path: string): string => {
  const parts = path.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = config;

  for (const part of parts) {
    if (current && typeof current === 'object' && part in current) {
      current = current[part];
    } else {
      throw new Error(`Configuration path not found: ${path}`);
    }
  }

  return current;
};

export default { get };
